module.exports = __webpack_public_path__ + "static/media/img_cards.9799cd1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_cards.png
// module id = 338
// module chunks = 0